export enum KnowledgeEvents {
  CREATE_DRAFT_ARTICLE = "create_draft_article",
  COPY_DRAFT_ARTICLE = "copy_draft_article",
}
